import React from 'react';
import {
  ANCHOR_PRIVATE_GALLERY,
  ANCHOR_PRIVATE_GALLERY_IMAGES,
  ANCHOR_PRIVATE_GALLERY_IMAGE,
  ANCHOR_PRIVATE_GALLERY_COVER
 } from '../../../constants/apiUrls/apiUrls';
import Modal from 'simple-react-modal';
import AddPhotos from './AddPhotos';
import callApi from '../../../utils/callApi';
import http from '../../../services/http';
import Loading from 'react-simple-loading';
import PhotoGallery from './PhotoGallery';
import './AnchorGallery.css';
import Alert from '../../../components/generalComponents/Alert';
import BackButton from '../../../components/generalComponents/BackButton/BackButton';
import NoData from '../../../components/generalComponents/NoData/NoData';
import { isMobileOnly } from 'react-device-detect';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import EditIcon from '@material-ui/icons/Edit';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AnchorDashboardHeader from '../../../components/AnchorDashboardHeader/AnchorDashboardHeader';

class AnchorGallery extends React.PureComponent {

  state = {
    gallery: null,
    loading: true,
    showDeleteImageConfirmation: false,
    showDeleteGalleryConfirmation: false,
    showGalleryOptions: false,
    showEditNameModal: false,
    galleryName: '',
    imageToDelete: null,
    showAlert: false,
    alertType: '',
    alertMessage: ''
  };

  componentDidMount() {
    this.getGalleryData();
  }

  handleClickOutside = () => {
    if(this.state.showGalleryOptions) {
      this.setState({ showGalleryOptions: false });
    }
  }

  openDeleteImageConfirmation = () => this.setState({ showDeleteImageConfirmation: true });
  closeDeleteImageConfirmation = () => this.setState({ showDeleteImageConfirmation: false });
  openDeleteGalleryConfirmation = () => this.setState({ showDeleteGalleryConfirmation: true });
  closeDeleteGalleryConfirmation = () => this.setState({ showDeleteGalleryConfirmation: false });
  openEditNameModal = () => this.setState({ showEditNameModal: true });
  closeEditNameModal = () => this.setState({ showEditNameModal: false, galleryName: '' });
  toggleGalleryOptions = () => {
    this.setState(state => {
      return { showGalleryOptions: !state.showGalleryOptions }
    });
  }

  getGalleryData = () => {
    const { user, match } = this.props;
    const anchorId = user.user.account.anchor.id;
    const galleryId = match.params.galleryId;
    const privateGalleryUrl = ANCHOR_PRIVATE_GALLERY
                              .replace('{id}', encodeURIComponent(anchorId))
                              .replace('{galleryId}', encodeURIComponent(galleryId));

    callApi(privateGalleryUrl, 'GET', undefined, undefined, undefined, true, true, true)
    .then(res => {
      if ( res.status === 200 && res.data ) {
        this.setState({
          gallery: res.data
        });
      }
      this.setState({ loading: false});
    })
    .catch(error => {
      this.setState({ loading: false});
      console.error(error);
    })
  }

  onImageDrop = (files) => {
    const { user, match } = this.props;
    const anchorId = user.user.account.anchor.id;
    const galleryId = match.params.galleryId;

    const formData = new FormData();

    files.forEach(file => {
      formData.append('images', file);
    });
    const url = ANCHOR_PRIVATE_GALLERY_IMAGES.replace('{id}', anchorId).replace('{galleryId}', galleryId);
    this.setState({ loading: true });
    http.post(
      url,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data'}
    })
    .then(res => {
      this.setState({ loading: false });
      if (res.data && res.status === 200) {
        this.setState({ gallery: res.data });
      }
    })
    .catch(error => {
      this.setState({ loading: false });
      console.error(error);
    })
  }

  onImageDropReject = files => {
    this.setState({
      showAlert: true,
      alertMessage: "Image has been rejected",
      alertType: "error"
    });
  }

  deleteImage = (imageId) => {
    const { user, match } = this.props;
    const anchorId = user.user.account.anchor.id;
    const galleryId = match.params.galleryId;
    const url = ANCHOR_PRIVATE_GALLERY_IMAGE
                .replace('{id}', encodeURIComponent(anchorId))
                .replace('{galleryId}', encodeURIComponent(galleryId))
                .replace('{imageId}', encodeURIComponent(imageId));

    callApi(url, 'DELETE', undefined, undefined, undefined, true, true, true)
    .then(res => {
      if (res.status === 200) {
        this.getGalleryData();
      }
    })
    .catch(error => {
      console.error(error);
    });
    this.setState({
      showDeleteImageConfirmation: false,
      imageToDelete: null
    });
  }

  cancelDeleteImage = () => {
    this.closeDeleteImageConfirmation();
    this.setState({ imageToDelete: null });
  }

  onDeleteImage = (image) => {
    this.openDeleteImageConfirmation();
    this.setState({ imageToDelete: image.id });
  }

  onDownloadImage = (url) => {
    window.open(url, 'Download');
  }

  onSetAsCover = (imageId) => {
    const { user, match } = this.props;
    const anchorId = user.user.account.anchor.id;
    const galleryId = match.params.galleryId;
    const url = ANCHOR_PRIVATE_GALLERY_COVER
                .replace('{id}', encodeURIComponent(anchorId))
                .replace('{galleryId}', encodeURIComponent(galleryId))
                .replace('{imageId}', encodeURIComponent(imageId));

    http.put(url)
      .then(res => {
        if (res.data && res.status === 200) {
          this.setState({
            gallery: res.data,
            showAlert: true,
            alertType: 'success',
            alertMessage: 'Your cover photo has been changed.'
          });
        }
      }).catch(error => {
        console.error(error);
      })
  }

  updateGalleryName = () => {
    const { user, match } = this.props;
    const { galleryName } = this.state;
    const anchorId = user.user.account.anchor.id;
    const galleryId = match.params.galleryId;
    const privateGalleryUrl = ANCHOR_PRIVATE_GALLERY
                              .replace('{id}', encodeURIComponent(anchorId))
                              .replace('{galleryId}', encodeURIComponent(galleryId));

    const data = {id: galleryId, name: galleryName};
    callApi(privateGalleryUrl, 'PUT', false, data, {}, false, true, true)
    .then(res => {
      if (res.status === 200) {
        this.getGalleryData();
        this.closeEditNameModal();
      }
    })
    .catch(error => {
      console.error(error);
    });
  }

  onGalleryNameChange = (e) => {
    e.preventDefault();
    this.setState({galleryName: e.target.value})
  }

  cancelDeleteGallery = () => {
    this.closeDeleteGalleryConfirmation();
  }

  deleteGallery = () => {
    const { user, match, history } = this.props;
    const anchorId = user.user.account.anchor.id;
    const galleryId = match.params.galleryId;
    
    const url = ANCHOR_PRIVATE_GALLERY
                  .replace('{id}', encodeURIComponent(anchorId))
                  .replace('{galleryId}', encodeURIComponent(galleryId));
    
    callApi(url, 'DELETE', false, {}, {}, false, true, true)
    .then(res => {
      history.goBack();
    })
    .catch(err => console.log(err));
  }

  arrangePhotos = (images) => {
    const { user, match } = this.props;
    const { gallery } = this.state;
    const anchorId = user.user.account.anchor.id;
    const galleryId = match.params.galleryId;
    
    const url = ANCHOR_PRIVATE_GALLERY
                  .replace('{id}', anchorId)
                  .replace('{galleryId}', galleryId);
    
    const photos = images.map((image, index) => {
      return {
        id: image.id,
        position: index
      };
    });
    
    const data = {
      id: galleryId,
      name: gallery.name,
      images: photos
    };
    
    callApi(url, 'PUT', false, JSON.stringify(data), {}, false, true, true)
    .then(res => {
      if ( res.status === 200 && res.data ) {
        this.setState({
          gallery: res.data
        });
      }
    })
    .catch(error => {
      console.error(error);
    });
  }

  hideAlert = () => {
    this.setState({
       showAlert: false,
       alertMessage: '',
       alertType: ''
    })
 }

  render() {
    const {
      loading,
      gallery,
      showDeleteImageConfirmation,
      showDeleteGalleryConfirmation,
      showGalleryOptions,
      showEditNameModal,
      galleryName,
      showAlert,
      alertType,
      alertMessage
    } = this.state;

    const photoGallery = gallery && gallery.images && gallery.images.map(img => {
      return {
        id: img.id,
        src: img.url,
        width: img.width,
        height: img.height,
        position: img.position
      }
    });

    const noData = gallery && gallery.images ? gallery.images.length === 0 : false;
    
    return (
      <div className="content">
        <AnchorDashboardHeader heading={'Gallery'} />
        {loading && <div style={{ padding: '20px 0' }}><Loading /></div>}
        {gallery && (
          <div onClick={this.handleClickOutside}>
            <div className="container">
              <div className="anchor-gallery-wrapper anchor-dashboard-min-height">
              {showAlert && (
                  <Alert onClose={this.hideAlert} type={alertType}>
                      {alertMessage}
                  </Alert>
              )}
                { 
                  <ul className="gallery-options" style={{display: `${showGalleryOptions ? 'block' : 'none'}`}}>
                    <li 
                      className="gallery-options__action" 
                      onClick={this.openEditNameModal}>
                        <EditIcon /> Edit Name
                    </li>
                    <li
                      className="gallery-options__action">
                        <AddPhotoAlternateIcon />
                        <AddPhotos 
                          onDrop={this.onImageDrop}
                          onDropRejected={this.onImageDropReject}/>
                    </li>
                    <li
                      className="gallery-options__action"
                      onClick={this.openDeleteGalleryConfirmation}>
                        <DeleteForeverIcon /> Delete Gallery
                    </li>
                  </ul>
                }
                {isMobileOnly ? (
                  <div className="mobile-gallery-back">
                    <BackButton
                      fontSize="32px"
                      link="/dashboard/galleries"
                    />
                    <span className="anchor-gallery-h1--mobile" style={{marginBottom: '10px'}}>
                      {gallery.name}
                    </span>
                    <span
                      style={{top: '20px'}}
                      className="anchor-gallery-options"
                      onClick={this.toggleGalleryOptions}
                    
                    >
                      <MoreHorizIcon fontSize="large" />
                    </span>
                  </div>
                ) : (
                  <React.Fragment>
                    <p className="post-creds">
                      <span>
                        {gallery.images.length} {gallery.images.length === 1 ? "IMAGE" : "IMAGES"}
                      </span>
                      <span
                        className="anchor-gallery-options"
                        onClick={this.toggleGalleryOptions}
                      
                      >
                        <MoreHorizIcon fontSize="large" />
                      </span>
                    </p>
                    <span className="h1 anchor-gallery-h1" style={{marginBottom: '10px'}}>
                      {gallery.name}
                    </span>
                  </React.Fragment>
                )}
                <div id="anchor-masonry-gallery" className="anchor-masonry-wrapper">
                  <PhotoGallery 
                    onDownloadImage={this.onDownloadImage} 
                    onSetAsCover={this.onSetAsCover} 
                    deleteImage={this.deleteImage}
                    photos={photoGallery}
                    arrangePhotos={this.arrangePhotos}/>
                </div>
                {noData ? <NoData category="Images" customClass='anchor-gallery-no-data' /> : null}
              </div>
            </div>
            <Modal
              show={showDeleteImageConfirmation}
            >
              <div className="anchor-gallery-delete-confirmation">
                <h4>Are you sure you want to delete this image?</h4>
                <div>
                  <button className="btn btn-join caps" onClick={this.deleteImage}>Delete</button>
                  <button className="btn caps" onClick={this.cancelDeleteImage}>Cancel</button>
                </div>
              </div>
            </Modal>

            <Modal
              show={showDeleteGalleryConfirmation}
              containerStyle={{width: `${isMobileOnly ? '310px' : '400px'}`}}
            >
              <div className="anchor-gallery-delete-confirmation">
                <h4>Are you sure you want to delete this gallery?</h4>
                <div>
                  <button className="btn btn-join caps" onClick={this.deleteGallery}>Delete</button>
                  <button className="btn caps" onClick={this.cancelDeleteGallery}>Cancel</button>
                </div>
              </div>
            </Modal>

            <Modal
              show={showEditNameModal}
              containerStyle={{width: `${isMobileOnly ? '310px' : '400px'}`}}
            >
              <div className="anchor-gallery-delete-confirmation">
              <div className="anchor-gallery-name-input">
                <label
                  htmlFor='anchor-new-gallery-name'
                >
                  Gallery Name
                </label>
                <input
                  id="anchor-new-gallery-name"
                  type="text"
                  value={galleryName}
                  onChange={this.onGalleryNameChange}
                />
              </div>
                <div>
                  <button className="btn btn-join caps" onClick={this.updateGalleryName}>Update Name</button>
                  <button className="btn caps" onClick={this.closeEditNameModal}>Cancel</button>
                </div>
              </div>
            </Modal>
          </div>
        )}
      </div>
    )
  }
}

export default AnchorGallery;
